module.exports = __webpack_public_path__ + "images/8135a7c8c20614adaa57561e51574de8-illu_key_logo.svg";